if (!customElements.get('mmx-featured-product-upsell')) {
  customElements.define(
    'mmx-featured-product-upsell',
    class MmxFeaturedProductUpsell extends HTMLElement {
      constructor() {
        super();

        this.addButton = this.querySelector('[data-upsell-add]');
        this.addedLabel = this.querySelector('[data-upsell-added]');
        this.variantSelect = this.querySelector('[data-upsell-variant-select]');
        this.variantId = this.dataset.variantId;
        this.sellingPlanId = this.dataset.sellingPlanId || '';
        this.addedDuration = parseInt(this.dataset.addedDuration, 10) || 2500;
        this.addedTimeout = null;

        this.addButton?.addEventListener('click', this.onAdd.bind(this));
        this.variantSelect?.addEventListener('change', this.onVariantChange.bind(this));
      }

      disconnectedCallback() {
        this.clearAddedTimeout();
      }

      get cart() {
        return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      }

      clearAddedTimeout() {
        if (this.addedTimeout) {
          clearTimeout(this.addedTimeout);
          this.addedTimeout = null;
        }
      }

      showAdded() {
        this.clearAddedTimeout();
        this.addButton?.classList.add('hidden');
        this.addedLabel?.classList.remove('hidden');

        this.addedTimeout = setTimeout(() => {
          this.addedTimeout = null;
          this.setAddState();
        }, this.addedDuration);
      }

      setAddState() {
        this.clearAddedTimeout();
        this.addButton?.classList.remove('hidden');
        this.addedLabel?.classList.add('hidden');
      }

      onVariantChange() {
        if (!this.variantSelect) return;

        this.variantId = this.variantSelect.value;
        this.dataset.variantId = this.variantId;

        const selectedOption = this.variantSelect.selectedOptions[0];
        const isAvailable = selectedOption && !selectedOption.disabled;
        this.sellingPlanId = selectedOption?.dataset.sellingPlanId || this.dataset.sellingPlanId || '';

        if (this.addButton) {
          if (isAvailable) {
            this.addButton.removeAttribute('disabled');
          } else {
            this.addButton.setAttribute('disabled', '');
          }
        }

        this.setAddState();
      }

      setLoading(button, loading) {
        if (!button) return;

        button.classList.toggle('loading', loading);
        button.toggleAttribute('aria-disabled', loading);
        button.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
      }

      onAdd() {
        if (
          this.addButton?.hasAttribute('disabled') ||
          this.addButton?.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        this.setLoading(this.addButton, true);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', this.variantId);
        formData.append('quantity', '1');

        if (this.sellingPlanId) {
          formData.append('selling_plan', this.sellingPlanId);
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error(response.description || response.message);
              return;
            }

            this.updateCartSections(response);

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'mmx-featured-product-upsell',
              productVariantId: this.variantId,
              cartData: response,
            });

            this.showAdded();
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.setLoading(this.addButton, false);
          });
      }

      updateCartSections(parsedState) {
        if (!parsedState.sections || !this.cart) return;

        this.cart.getSectionsToRender().forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);

          if (!sectionElement || !parsedState.sections[section.id]) return;

          sectionElement.innerHTML = this.cart.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
        });

        this.cart.classList.toggle('is-empty', parsedState.item_count === 0);
      }
    }
  );
}
